import { KEYS } from "../Keys";

export const createKnockoutSchedule = async (values) => {
  const response = await fetch(KEYS.API + "/eventschedule/createknockoutslot", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${localStorage.getItem("userToken")}`
    },
    body: JSON.stringify(values)
  });
  return response;
};

export const updateKnockoutRound = async (values) => {
  const response = await fetch(KEYS.API + "/eventschedule/updateknockoutrounds", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${localStorage.getItem("userToken")}`
    },
    body: JSON.stringify(values)
  });
  return response;
};

export const getKnockoutScheduleRoundData = async (values) => {
  const response = await fetch(KEYS.API + "/eventschedule/getknockouteventdetails", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${localStorage.getItem("userToken")}`
    },
    body: JSON.stringify(values)
  });
  return response;
};

export const updateKnockoutMatchWinner = async (values) => {
  const response = await fetch(KEYS.API + "/eventschedule/updatematchwinner", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${localStorage.getItem("userToken")}`
    },
    body: JSON.stringify(values)
  });
  return response;
};
